<template>
  <div class="page-wrapper">
    <TrfGlobalLoader v-if="isFormLoading" v-e2e="'form-loader'" type="fixed" />

    <div class="container" v-if="keyValida && !possuiStatusAConferir && !possuiTodasFasesConcluidas && ((!this.isVisualizacao && this.isStatusValidoParaVisualizarForm) || this.isVisualizacao)">
      <TrfHeader :pageTitle="pageTitle"></TrfHeader>
      <div
        v-if="ajustes"
        class="ajustes is-flex is-flex-direction-column is-align-items-center p-4 mb-4"
      >
        <b class="pb-3">Atenção!</b>
        <div class="content" v-html="ajustes"></div>
      </div>
      
      <div class="is-flex is-justify-content-center">
        <div v-if="isFormularioPersonalizado" class="box-form-personalizado">
          <TrfPreenchimentoForm
            ref="formPreenchimento"
            :pModeloFormulario="modelo"
            :pFormData="formPersonalizado"
            :pProcessoHasAnexos="processoHasAnexos"
            :pIsPreenchimento="!isConferencia"
            :pIsConferencia="isConferencia"
            @update:form-data="setFormData"
            @update:campo-padrao="($event) => setFormData($event, true)"
            @add:socio="setSocio"
            @elegalize-excluir-formulario-socio.capture="excluirSocioPersonalizado"
          ></TrfPreenchimentoForm>
        </div>
        <div v-else class="box-formulario">
          <TrfEmpresaFormularioBase
            ref="formEmpresa"
            :listagem-de-socios="socios.dados"
            :isVisualizacao="isVisualizacao"
            @elegalize-iniciar-formulario-socio.capture="inicializaFormSocio"
            @elegalize-editar-formulario-socio.capture="editaFormSocio"
            @elegalize-visualizar-formulario-socio.capture="visualizaFormSocio"
            @elegalize-excluir-formulario-socio.capture="excluiFormSocio"
            @update:form-data="($event) => setEmpresa($event)"
            :preview="isPreview"
            :showMaisAcoesSocios="true"
            :acoesAnexo="isVisualizacao? [] : ['excluir']"
          />

          <TrfSimpleModal
            :titulo="configsModalCadastroDeSocios.titulo"
            :isAtivo="configsModalCadastroDeSocios.isAtivo"
            :isFecharComBackground="false"
            idModal="modal-dados-socio"
            :isModalPersonalizado="true"
            :isScrollPersonalizado="true"
            @close="doFecharModalSocio"
          >
            <TrfFormularioBaseSocio
              ref="formSocio"
              @concluir-cadastro-socio="($event) => concluidoCadastroSocio($event)"
              @concluir-edicao-socio="($event) => concluidoEdicaoSocio($event)"
              :preview="isPreview"
              :isVisualizacao="isVisualizacao"
            ></TrfFormularioBaseSocio>

            <template #slot-footer>
              <div class="buttons">
                <TrfButton
                  v-if="!isConferencia"
                  :nome="configsModalCadastroDeSocios.labelConfirma"
                  classCor="is-primary"
                  id="btn-enviar-formulario"
                  @click="configsModalCadastroDeSocios.acaoConfirma"
                />
                <TrfButton :nome="configsModalCadastroDeSocios.labelCancela" id="btn-cancelar-envio-formulario" @click="doFecharModalSocio" />
              </div>
            </template>
          </TrfSimpleModal>
        </div>
      </div>
      <hr />
      <div class="buttons is-flex is-justify-content-flex-end my-6">
        <TrfButton v-if="!isConferencia"
          id="btn-a-concluir-formulario"
          classCor="is-primary"
          nome="A concluir"
          :disabled="configsBtnsView.isLoading || isBtnAConcluirLoading"
          :is-btn-loading="isBtnAConcluirLoading"
          @click="async($event) => await aConcluirFormularioPelaKey($event)"
          title="Salvar os dados preenchidos e continuar depois."
        />
        <TrfButton
          id="btn-salvar-formulario"
          classCor="is-primary"
          :nome="configsBtnsView.labelConfirma"
          :disabled="configsBtnsView.isLoading || isBtnAConcluirLoading"
          :is-btn-loading="configsBtnsView.isLoading"
          @click="configsBtnsView.acaoConfirma"
          :title="tooltipConfirmar"
        />
        <TrfButton
          v-if="isVisualizacao"
          id="btn-reenviar-formulario"
          classCor="is-primary"
          :nome="configsBtnsView.labelReenvio"
          :disabled="configsBtnsView.isLoading || isBtnReenvioLoading"
          :is-btn-loading="configsBtnsView.isLoading"
          @click="configsBtnsView.acaoReenvio"
          title="Reenviar formulário"
        />
        <TrfButton
          id="btn-cancelar-formulario"
          :nome="configsBtnsView.labelCancela"
          :disabled="configsBtnsView.isLoading || isBtnAConcluirLoading"
          @click="configsBtnsView.acaoCancela"
        />
      </div>
      <TrfSimpleModal
        titulo="Reenviar formulário"
        :isAtivo="modalReenvioComAjustes.isAtivo"
        :isFecharComBackground="false"
        :isModalPersonalizado="true"
        idModal="modal-reenvio-formulario-com-ajustes"
        @close="doFecharModalReenvioComAjustes"
      >
        <div>
          <p v-if="hasTokenIntegracaoWhatsapp && processo?.pessoaContatoWpp">
            Confirma o reenvio do formulário por e-mail e WhatsApp para a pessoa de contato da abertura do negócio <b>{{processo?.nomeNegocio}}</b>?
          </p>

          <p v-else>
            Confirma o reenvio do formulário por e-mail para a pessoa de contato da abertura do negócio <b>{{processo?.nomeNegocio}}</b>?
          </p>

          <br><br>
          <b>
            Se houver necessidade de ajustes nas informações preenchidas anteriormente, digite abaixo as instruções para o seu cliente, e elas serão exibidas no formulário reenviado.
          </b>

          <TrfToolbarTextEditor
            v-if="modalReenvioComAjustes.isAtivo"
            :tipLabel="tipLabelReenvio"
            :maxlength="modalReenvioComAjustes.maxlength"
            @changeText="doChangeAjustesText"
            ref="modalReenvioComAjustesText"
          ></TrfToolbarTextEditor>
          <p v-if="hasTokenIntegracaoWhatsapp && processo?.pessoaContatoWpp" class="is-size-7 mt-5">
            <b>Atenção:</b> A notificação de revisão será enviada por WhatsApp com o conteúdo digitado neste modal, porém sem os estilos de texto aplicados, devido às limitações da plataforma quanto à formatação avançada.
          </p>
        </div>
        <template #slot-footer>
          <div class="buttons">
            <TrfButton
                @click="doEnviarFormularioComAjustes"
                classCor="is-primary"
                nome="Reenviar"
                :isBtnLoading="modalReenvioComAjustes.isLoading"
              />
              <TrfButton
                @click="doFecharModalReenvioComAjustes"
                nome="Cancelar"
                :disabled="modalReenvioComAjustes.isLoading"
              />
          </div>
        </template>
      </TrfSimpleModal>
    </div>

    <TrfPaginaErro :tituloDeErro="tituloErroNaoEncontrado" :mensagemDeErro="mensagemErroNaoEncontrado" v-else-if="!keyValida" />

    <TrfPaginaErro :tituloDeErro="tituloErroFasesConcluidas" :mensagemDeErro="mensagemErroFasesConcluidas" v-else-if="possuiTodasFasesConcluidas" />

    <TrfPaginaErro urlImagem="/img/form_success.png" :tituloDeErro="tituloErroStatusAConferir" :mensagemDeErro="mensagemErroStatusAConferir" v-else-if="!isVisualizacao && !isStatusValidoParaVisualizarForm" />
  </div>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import { toastUtils } from '../../../util/toast.utils.js';
import { routerUtils } from '../../../util/router.utils.js';
import FormularioElegalize from '../Formulario/Models/formulario-elegalize-model.js';
import DadosEmpresa from '../CadastroDeProcessos/Models/dados-empresa.model';
import DadosSocio from '../CadastroDeProcessos/Models/dados-socio.model.js';
import { camposEnderecoStore } from '../../../stateManagement/camposEndereco.js';
import { camposSocioStore } from '../../../stateManagement/camposSocio.js';
import Formulario from '../../../model/formulario.model.js';
import { ToastBuilder, toastTypeEnum } from '../../../builder/toast.builder.js';
import { configuracoesStore } from '../../../stateManagement/configuracoes.js';

const formIncompletoToast = new ToastBuilder();
formIncompletoToast.setType(toastTypeEnum.DANGER);
formIncompletoToast.setMessage('Campo(s) obrigatório(s) e/ou inválido(s)!');

export default {
  name: 'ELegalizeFormularioBase',
  components: {
    TrfGlobalLoader: defineAsyncComponent(() => import('../../../components/GlobalLoader/index.vue')),
    TrfHeader: defineAsyncComponent(() => import('../../../components/Header/index.vue')),
    TrfEmpresaFormularioBase: defineAsyncComponent(() => import('../CadastroDeProcessos/Components/FormularioBaseEmpresa.vue')),
    TrfFormularioBaseSocio: defineAsyncComponent(() => import('../CadastroDeProcessos/Components/FormularioBaseSocio.vue')),
    TrfSimpleModal: defineAsyncComponent(() => import('../../../components/Modal/TrfSimpleModal.vue')),
    TrfButton: defineAsyncComponent(() => import('../../../components/Button/index.vue')),
    TrfPaginaErro: defineAsyncComponent(() => import('../../../components/PaginaErro/index.vue')),
    TrfPreenchimentoForm: defineAsyncComponent(() => import('../../../components/PreenchimentoForm/index.vue')),
    TrfToolbarTextEditor: defineAsyncComponent(() => import('../../../components/ToolbarTextEditor/index.vue')),
  },
  props: {
    statusTela: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      modelo: new FormularioElegalize(),
      processoHasAnexos: false,
      camposPersonalizados: [],
      key: '',
      keyValida: true,
      empresa: new DadosEmpresa(),
      isLoaded: false,
      socios: {
        dados: [],
        originalIndex: 0
      },
      configsModalCadastroDeSocios: {
        isAtivo: false,
        titulo: 'Cadastrar sócio',
        labelConfirma: 'Cadastrar sócio',
        labelCancela: 'Cancelar',
        isEdicao: false,
        acaoConfirma: () => {}
      },
      configsBtnsView: {
        labelConfirma: 'Salvar',
        labelCancela: 'Cancelar',
        labelReenvio: 'Reenviar',
        acaoConfirma: () => {},
        acaoCancela: () => {},
        acaoReenvio: () => {},
        isLoading: false
      },
      formId: null,
      isPreview: false,
      isFormLoading: true,
      camposEnderecoStore: camposEnderecoStore,
      possuiStatusAConferir: false,
      isStatusValidoParaVisualizarForm: true,
      possuiTodasFasesConcluidas: false,
      isVisualizacao: false,
      aConcluir: false,
      isBtnAConcluirLoading: false,
      isBtnReenvioLoading: false,
      isFormValido: false,
      ajustes: null,
      processo: null,
      modalReenvioComAjustes: {
        ajustes: null,
        ajustesPlainText: null,
        isLoading: false,
        isAtivo: false,
        maxlength: 5000
      },
    };
  },
  async beforeRouteEnter(to, from, next) {
    const isVisualizacao = to.path.includes('visualizar');
    const id = to.params.id;
    if (!!id && isVisualizacao) {
      next(async (vm) => {
        vm.isVisualizacao = true;
        await camposEnderecoStore.adquirirTodosOsCampos();
        await camposSocioStore.adquirirTodosOsCampos();
        vm.formId = id;
        vm.isPreview = true;
        await vm.getDadosDoFormulario();
      });
    } else {
      next(async (vm) => {
        await camposEnderecoStore.adquirirTodosOsCampos();
        await camposSocioStore.adquirirTodosOsCampos();
        vm.key = to.query.key;
        await vm.getDadosDoFormulario();
      });
    }
  },
  async beforeRouteUpdate(to) {
    const isVisualizacao = to.path.includes('visualizar');
    const id = to.params.id;
    await camposEnderecoStore.adquirirTodosOsCampos();
    await camposSocioStore.adquirirTodosOsCampos();
    if (!!id && isVisualizacao) {
      this.formId = id;
      this.isVisualizacao = true;
      this.isPreview = true;
      await this.getDadosDoFormulario();
    } else {
      this.key = to.query.key;
      await this.getDadosDoFormulario();
    }
  },
  computed: {
    pageTitle() {
      return this.isVisualizacao ? 'Conferir formulário' : this.modelo.nomeNegocio;
    },
    tituloErroNaoEncontrado() {
      return '<h1 class="is-size-3">Não foi possível acessar o formulário!</h1>'
    },
    mensagemErroNaoEncontrado() {
      return '<p>Parece que o formulário de legalização referente ao seu negócio não existe mais.</p><p>Entre em contato com os responsáveis pelo envio.</p>'
    },
    tituloErroStatusAConferir() {
      return '<h1 class="is-size-3">Formulário enviado com sucesso!</h1>'
    },
    mensagemErroStatusAConferir() {
      return '<p>O formulário já foi preenchido e enviado com sucesso. Em caso de dúvidas, entre em contato com o responsável pelo recebimento das informações.</p>'
    },
    tituloErroFasesConcluidas() {
      return '<h1 class="is-size-3">Não foi possível acessar o formulário!</h1>'
    },
    mensagemErroFasesConcluidas() {
      return '<p>O formulário de legalização não é mais válido, pois o processo já foi concluído. Por favor, entre em contato com os responsáveis pelo envio.</p>'
    },
    tooltipConfirmar() {
      return this.isVisualizacao? 'Confirmar a conferência do formulário.' : 'Salvar os dados e enviar para conferência.'
    },
    isFormularioPersonalizado() {
      return Array.isArray(this.camposPersonalizados) && this.camposPersonalizados.length > 0
    },
    formPersonalizado() {
      const formPersonalizado = new Formulario();
      formPersonalizado.asModel({camposPersonalizados: this.camposPersonalizados})
      return formPersonalizado
    },
    isConferencia() {
      return this.isVisualizacao;
    },
    hasTokenIntegracaoWhatsapp() {
      return configuracoesStore.hasTokenIntegracaoWhatsapp;
    },
    tipLabelReenvio() {
      let count = this.modalReenvioComAjustes.maxlength;
      if(this.modalReenvioComAjustes.ajustesPlainText) {
        count -= this.modalReenvioComAjustes.ajustesPlainText.length;
      }
      return count + ` caracteres restantes`;
    }
  },
  methods: {
    async importFormularioService() {
      const { formularioService } = await import('../../../service/formulario-service.js');
      return formularioService;
    },
    async importProcessoService() {
      const { processoService } = await import('../../../service/processo-service.js');
      return processoService;
    },
    setEmpresa(valor) {
      if (!valor) return;
      this.modelo.empresa = valor;
      this.updateModel(this.modelo.empresa);
    },
    setSocios() {
      this.socios.dados = this.modelo.empresa.socios;
      this.socios.dados.forEach((item) => {
        item.originalIndex = this.socios.originalIndex;
        this.socios.originalIndex = this.socios.originalIndex + 1;
      });
    },
    setConfigsBtnsView(labelConfirma, labelCancela, acaoConfirma, acaoCancela, labelReenvio = "Reenviar", acaoReenvio = () => {}, ) {
      this.configsBtnsView.labelConfirma = labelConfirma;
      this.configsBtnsView.labelCancela = labelCancela;
      this.configsBtnsView.labelReenvio = labelReenvio;
      this.configsBtnsView.acaoConfirma = acaoConfirma;
      this.configsBtnsView.acaoCancela = acaoCancela;
      this.configsBtnsView.acaoReenvio = acaoReenvio;
    },
    setFormData(formData, isCampoPadrao) {
      if (isCampoPadrao) {
        this.updateModel(formData.formData)
      } else {
        this.modelo.updateDados(formData)
      }
    },
    updateModel(formData) {
      this.modelo.empresa.updateDados(formData);
    },
    async getDadosDoFormulario() {
      if(this.isLoaded) return;
      try {
        this.isFormLoading = true;
        const formularioService = await this.importFormularioService();
        let response = {};

        if (!this.isVisualizacao) {
          const filtro = { key: this.key };
          response = await formularioService.getDadosPelaKey(filtro);
          this.setConfigsBtnsView('Salvar', 'Cancelar', this.salvarFormularioPelaKey, this.doVoltar);
        } else {
          response = await formularioService.getDadosPeloId(this.formId);
          this.setConfigsBtnsView('Confirmar', 'Fechar', this.doConfirmarDadosDoForm, this.doVoltar, "Reenviar", this.doConfirmarReenvio);
        }
        this.processoHasAnexos = response?.hasAnexos;
        this.possuiStatusAConferir = response?.possuiProcessoComStatusAConferir;
        this.possuiTodasFasesConcluidas = response?.possuiTodasFasesConcluidas;
        this.isStatusValidoParaVisualizarForm = response?.isStatusValidoParaVisualizarForm;
        this.ajustes = response?.ajustes;

        this.camposPersonalizados = response.camposPersonalizados
        this.modelo.asModel(response, this.key);
        this.setSocios();
        this.$refs.formEmpresa.inicializarCampos(this.modelo.empresa);
       
        if(this.isVisualizacao) {
           this.processo = await this.getDadosProcesso(response.processoId);
        }
      } catch (e) {
        if (e.message.includes('404')) {
          this.keyValida = false;
        }
        console.warn(`WARN: ${e}`);
      } finally {
        this.isFormLoading = false;
        this.isLoaded = true;
      }
    },
    async getDadosProcesso(processoId) {
      if (!processoId) return null;
      try {
        const processoService = await this.importProcessoService();
        const processo = await processoService.adquirirPorId(processoId);
        return processo;
      } catch (e) {
        console.warn(`ERR: ${e}`);
        return null;
      }
    },
    async salvarFormularioPelaKey() {
      this.modelo.hasAnexos = this.processoHasAnexos;
      const validacaoPersonalizada = await this.doValidarDadosCadastro();
      try {
        if((!this.isFormularioPersonalizado && !this.$refs.formEmpresa.validacoes.form) || (this.isFormularioPersonalizado && !validacaoPersonalizada)) {
          formIncompletoToast.toast()
          return;
        }

        if(!this.isSocioValido()) {
          toastUtils.dangerToast('O formulário \'Dados do sócio\' possui um ou mais campos obrigatórios que não foram preenchidos. Por favor, revise e preencha esses dados antes de prosseguir.');
          return;
        }

        this.configsBtnsView.isLoading = true;
        const formularioService = await this.importFormularioService();
        await formularioService.editarPelaKey(this.modelo.asRequestBody());
        routerUtils._substituiRota('/elegalize/form/enviado');
      } catch (e) {
        const message = e.message? e.message : 'Ocorreu um erro ao salvar as informações.';
        toastUtils.dangerToast(message); 
        console.warn(`WARN: ${e}`);
      } finally {
        this.configsBtnsView.isLoading = false;
      }
    },
    inicializaFormSocio(dados) {
      const details = dados.detail;
      this.setConfigsFormSocio(details.titulo, 'Cadastrar sócio', 'Cancelar', false, this.doCadastrarSocio);
    },
    async editaFormSocio(dados) {
      const details = dados.detail;
      this.setConfigsFormSocio(details.titulo, 'Editar sócio', 'Cancelar', true, this.doEditarSocio);
      await this.$nextTick();
      this.$refs.formSocio.inicializarCampos(details.dadosEdicao);
    },
    async visualizaFormSocio(dados) {
      const details = dados.detail;
      this.setConfigsFormSocio(details.titulo, 'Confirmar sócio', 'Fechar', false, null);
      await this.$nextTick();
      this.$refs.formSocio.inicializarCampos(details.dadosVisualizacao);
    },
    excluiFormSocio(event) {
      this.socios.dados.splice(event.detail.index, 1);
    },
    excluirSocioPersonalizado(event) {
      const index = event?.detail?.index;
      if (!Array.isArray(this.modelo?.empresa?.socios) || index == null || !this.modelo.empresa.socios[event.detail.index]) return;
      const socioEmExclusao = this.modelo.empresa.socios[event.detail.index];
      const idSocioEmExclusao = socioEmExclusao.id;
      const uuidSocioEmExclusao = socioEmExclusao.uuid;
      this.removerRespostasSocio(idSocioEmExclusao, uuidSocioEmExclusao);
      this.modelo.empresa.socios.splice(index, 1)
    },
    removerRespostasSocio(socioId, socioUuid) {
      for(let campoPersonalizado of this.camposPersonalizados) {
        if(!campoPersonalizado.isCampoSocio || !Array.isArray(campoPersonalizado.respostasSocios)) continue;
        const indexResposta = campoPersonalizado.respostasSocios.findIndex((resposta) => {
          return (socioId != null && resposta.processoSocioId == socioId) || (socioUuid != null && resposta.uuid == socioUuid);
        })
        if(indexResposta == -1) continue;
        campoPersonalizado.respostasSocios.splice(indexResposta, 1);
      }
    },
    setConfigsFormSocio(titulo, labelConfirma, labelCancela, isEdicao, acaoConfirma) {
      this.configsModalCadastroDeSocios.isAtivo = !this.configsModalCadastroDeSocios.isAtivo;
      this.configsModalCadastroDeSocios.titulo = titulo;
      this.configsModalCadastroDeSocios.labelConfirma = labelConfirma;
      this.configsModalCadastroDeSocios.isEdicao = isEdicao;
      this.configsModalCadastroDeSocios.acaoConfirma = acaoConfirma;
      this.configsModalCadastroDeSocios.labelCancela = labelCancela;
    },
    concluidoCadastroSocio(formData) {
      const socio = new DadosSocio();
      socio.updateDados(formData);
      socio.originalIndex = this.socios.originalIndex;
      this.socios.dados.push(socio);
      this.socios.originalIndex = this.socios.originalIndex + 1;
      this.doFecharModalSocio();
    },
    concluidoEdicaoSocio(formData) {
      const socio = new DadosSocio();
      socio.updateDados(formData);
      const indexSocioParaEdicao = this.socios.dados.findIndex((item) => socio.originalIndex == item.originalIndex);
      if (indexSocioParaEdicao !== -1) {
        this.socios.dados[indexSocioParaEdicao] = socio;
      }
      this.doFecharModalSocio();
    },
    async doFecharModalSocio() {
      this.$refs.formSocio.limparCampos();
      await this.$nextTick();
      this.configsModalCadastroDeSocios.isAtivo = false;
    },
    doCadastrarSocio() {
      this.$refs.formSocio.doCadastrar();
      this.$refs.formSocio.limparCampos();
    },
    doEditarSocio() {
      this.$refs.formSocio.doEditar();
      this.$refs.formSocio.limparCampos();
    },
    async doValidarDadosCadastro() {
      if(!this.isFormularioPersonalizado) return true;
      const resultadoValidacao = await this.$refs.formPreenchimento.doValidar()
      this.isFormValido = resultadoValidacao;
      return this.isFormValido
    },
    isSocioValido() {
      if(!this.isFormularioPersonalizado) return true;
      const isSocioObrigatorio = this.$refs.formPreenchimento.isSocioObrigatorio;
      return isSocioObrigatorio
        ? this.modelo.empresa.socios.length != 0
        : true;
    },
    async doConfirmarDadosDoForm() {
      try {
        this.configsBtnsView.isLoading = true;
        const formularioService = await this.importFormularioService();
        await formularioService.confirmarDados({ id: this.formId });
        toastUtils.successToast('Informações salvas com sucesso!');
        this.doVoltar();
      } catch (e) {
        toastUtils.dangerToast('Ocorreu um erro ao salvar as informações.');
        console.warn(`WARN: ${e}`);
      } finally {
        this.configsBtnsView.isLoading = false;
      }
    },
    doVoltar() {
      routerUtils._carregarNovaRota(`/elegalize`);
    },
    doConfirmarReenvio() {
      this.modalReenvioComAjustes.isAtivo = true;
    },
    doChangeAjustesText(value) {
      const plainText = this.$refs.modalReenvioComAjustesText.getValueAsText();
      if(plainText.length > this.modalReenvioComAjustes.maxlength) {
        return;
      }

      this.modalReenvioComAjustes.ajustes = value;
      this.modalReenvioComAjustes.ajustesPlainText = this.$refs.modalReenvioComAjustesText.getValueAsText();
    },
    async doEnviarFormularioComAjustes() {
      try {
        this.modalReenvioComAjustes.isLoading = true;
        const processoService = await this.importProcessoService();
        const requestBody = {
          processoId: this.processo.id,
          ajustes: this.modalReenvioComAjustes.ajustes,
          ajustesPlainText: this.modalReenvioComAjustes.ajustesPlainText
        }
        await processoService.enviarFormulario(requestBody);
        toastUtils.successToast("Formulário reenviado com sucesso!")
      } catch (e) {
        console.warn(`WARN: ${e}`)
        this.modalReenvioComAjustes.isLoading = false;
      } finally {
        this.doFecharModalReenvioComAjustes();
        this.doVoltar();
      }
    },
    doFecharModalReenvioComAjustes() {
      this.modalReenvioComAjustes.isAtivo = false;
    },
    async aConcluirFormularioPelaKey() {
      try {
        this.modelo.aConcluir = true;
        if(!this.isFormularioPersonalizado && !this.$refs.formEmpresa.validacoes.form) {
          toastUtils.dangerToast("Campo(s) com informações inválida(s)!");
          return;
        }

        this.isBtnAConcluirLoading = true;
        const formularioService = await this.importFormularioService();
        await formularioService.editarPelaKey(this.modelo.asRequestBody());
        toastUtils.successToast("Informações salvas com sucesso!");

        const currentUrl = window.location.href;
        routerUtils._substituiRota(`/elegalize/form/salvo?previousUrl=${currentUrl}`);
      } catch (e) {
        console.trace()
        toastUtils.dangerToast('Ocorreu um erro ao salvar as informações.');
        console.warn(`WARN: ${e}`);
      } finally {
        this.isBtnAConcluirLoading = false;
        this.modelo.aConcluir = false;
      }
    },
    setSocio(formData) {
        let socioIndex = this.modelo.empresa.socios.findIndex((socioModelo) => {
          return (formData.socio.id != null && socioModelo.id == formData.socio.id) || (socioModelo.uuid == formData.socio.uuid)
        })
        if (socioIndex != -1) {
          this.modelo.empresa.socios[socioIndex] = formData.socio;
        } else {
          this.modelo.empresa.socios.push(formData.socio);
        }
        for (let campoIndex in this.camposPersonalizados) {
          const campoNovo = formData.camposPersonalizados.find((novo) => {
            return (novo && novo.id === this.camposPersonalizados[campoIndex].id) || novo && novo.uuid === this.camposPersonalizados[campoIndex].uuid
          });

          const respostaNova = Array.isArray(campoNovo?.respostasSocios)? campoNovo?.respostasSocios[0] : campoNovo?.respostasSocios

          if(!respostaNova) continue;
          if (!Array.isArray(this.camposPersonalizados[campoIndex].respostasSocios)) {
            this.camposPersonalizados[campoIndex].respostasSocios = []
          }
          const respostaIndex = this.camposPersonalizados[campoIndex].respostasSocios.findIndex((resposta) => {
            return (respostaNova.id != null && resposta.id == respostaNova.id) || (respostaNova.processoSocioId != null && resposta.processoSocioId == respostaNova.processoSocioId) || (respostaNova.uuid != null && respostaNova.uuid && resposta.uuid == respostaNova.uuid)
          })
          if(respostaIndex != -1) {
            this.camposPersonalizados[campoIndex].respostasSocios[respostaIndex] = {
              id: this.camposPersonalizados[campoIndex].respostasSocios[respostaIndex].id,
              ...respostaNova
            };
            if (this.camposPersonalizados[campoIndex].respostasSocios[respostaIndex].id != null && this.camposPersonalizados[campoIndex].respostasSocios[respostaIndex].uuid != null) {
              delete this.camposPersonalizados[campoIndex].respostasSocios[respostaIndex].uuid
            };
          } else {
            this.camposPersonalizados[campoIndex].respostasSocios.push(respostaNova)
          }
        }
    },
  }
};
</script>
<style lang="scss" scoped>
.box-formulario {
  border-top: 0.75rem solid var(--primaryColor, #a82339);
  border-left: 1rem solid #666666;
  border-radius: 8px;
  padding: 2em;
  width: 100%;
  max-width: 750px;
  box-sizing: border-box;
  box-shadow: 2px 2px 2px #70757a66;
}

.ajustes {
  color: #8a6d3b;
  background-color: #fcf8e3;
  border: 1px solid #faebcc;
  border-radius: 4px;
  overflow-wrap: anywhere;
}
</style>

<style lang="scss">
#modal-dados-socio {
  .modal-card {
    width: 700px;
    max-width: 98%;
    .modal-card-body {
      padding: 1rem 2.25rem;
      overflow: auto;
    }
  }
}
#modal-reenvio-formulario-com-ajustes {
  .modal-card {
    width:700px;
    max-width:98%;
    .modal-card-body {
      padding: 1rem 2.25rem;
      overflow: auto;
    }
  }
}
</style>
